
import seo from '~/mixins/seo'
import marketing from '~/mixins/marketing'
export default {
  mixins: [marketing],
  computed: {
    isBusinessPage () { return /\/dla-biznesu\/?$/.test(this.$route.path) }
  },
  head () {
    // Merge explicitly: this layout also supplies fonts, so its head must not
    // replace the shared language/canonical metadata from the SEO mixin.
    const metadata = seo.head.call(this)
    return { ...metadata, link: [...metadata.link,
      { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
      { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap' }
    ] }
  }
}
